import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-container'>
        <div className='footer-content'>
          <div className='footer-section'>
            <h3 className='footer-title'>Money Minded Apes NFT Ranks</h3>
            <p className='footer-description'>
              Discover the rarity rankings of Money Minded Apes NFT collections. Track your apes and
              explore the most valuable traits.
            </p>
          </div>

          <div className='footer-section'>
            <h4 className='footer-heading'>Collections</h4>
            <ul className='footer-links'>
              <li>
                <Link to='/og-apes' className='footer-link'>
                  Money Minded Apes
                </Link>
              </li>
              <li>
                <Link to='/private-jet-apes' className='footer-link'>
                  Private Jet Apes
                </Link>
              </li>
              <li>
                <Link to='/xwar-apes' className='footer-link'>
                  X War Meta Apes
                </Link>
              </li>
              <li>
                <Link to='/top-g-apes' className='footer-link'>
                  Top G Apes
                </Link>
              </li>
              <li>
                <Link to='/mutants' className='footer-link'>
                  Money Minded Mutants
                </Link>
              </li>
              <li>
                <Link to='/pixel-apes' className='footer-link'>
                  Money Minded Pixel Apes
                </Link>
              </li>
              <li>
                <Link to='/mula-trees' className='footer-link'>
                  Money Minded Mula Trees
                </Link>
              </li>
              <li>
                <Link to='/ladies' className='footer-link'>
                  Money Minded Ladies
                </Link>
              </li>
            </ul>
          </div>

          <div className='footer-section'>
            <h4 className='footer-heading'>Quick Links</h4>
            <ul className='footer-links'>
              <li>
                <Link to='/' className='footer-link'>
                  Home
                </Link>
              </li>
              <li>
                <a
                  href='https://moneymindedapes.com/'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='footer-link'
                >
                  Official Website
                </a>
              </li>
              <li>
                <a
                  href='https://discord.gg/cYe6qzkBap'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='footer-link'
                >
                  Discord
                </a>
              </li>
            </ul>
          </div>

          <div className='footer-section'>
            <h4 className='footer-heading'>Social Media</h4>
            <ul className='footer-links'>
              <li>
                <a
                  href='https://x.com/moneymindedapes'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='footer-link'
                >
                  X (Twitter)
                </a>
              </li>
              <li>
                <a
                  href='https://discord.gg/cYe6qzkBap'
                  target='_blank'
                  rel='noopener noreferrer'
                  className='footer-link'
                >
                  Discord
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className='footer-disclaimer'>
          <div className='disclaimer-content'>
            <h4 className='disclaimer-title'>Rarity Ranking Disclaimer</h4>
            <p className='disclaimer-text'>
              There are many ways to rank NFT rarities, and we've provided several different ranking
              methods for you to choose from to see how you prefer them ranked. The Rarity Score
              method appears to be the most prevalent in the NFT community. Please note that rarity
              and value are subjective concepts. All rankings displayed on this website are official
              rankings calculated using established mathematical formulas. However, marketplace
              rarity rankings may differ from our calculations as different platforms may use
              alternative methodologies or data sources.
            </p>
          </div>
        </div>

        <div className='footer-bottom'>
          <div className='footer-divider'></div>
          <div className='footer-bottom-content'>
            <p className='footer-copyright'>
              © 2025 Money Minded Apes NFT Ranks. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
